export class SecurityCodeSearchTableView {
    public securityCode: string;
    public securityName: string;
    public groupName: string;
    public userLogon: string;
    public commitBy: string;
    public commitByName: string
    public commitDateTime: Date;
    public statusCode: string;
}